export default __webpack_public_path__ + "static/media/love-2.d1b7c64b.svg";